import { render, staticRenderFns } from "./TpvOk.vue?vue&type=template&id=044606de&"
import script from "./TpvOk.vue?vue&type=script&lang=js&"
export * from "./TpvOk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports